import type React from "react";
import { PostCardHeaderActions } from "@/components/common/PostCardHeaderActions";

interface PostCardHeaderActionAreaProps {
  isPending: boolean;
  isFavorited?: boolean;
  isFavoriting?: boolean;
  postContentId: number;
  onToggleFavorite?: (
    postContentId: number,
    isCurrentlyFavorited: boolean,
  ) => Promise<void>;
  onCopyLink?: () => void;
  isCurrentUserAuthor?: boolean;
  isGroupAdmin?: boolean;
  isPinned?: boolean;
  isMenuDisabled?: boolean;
  isDeleteDisabled?: boolean;
  hideOptionsButton?: boolean;
  isMinimized?: boolean;
  onToggleMinimize?: () => void;
  onReportClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onPinClick?: () => void;
  canMoveChannel?: boolean;
  onMoveChannelClick?: () => void;
}

export const PostCardHeaderActionArea: React.FC<
  PostCardHeaderActionAreaProps
> = ({ isPending, ...props }) => {
  if (isPending) {
    return null;
  }

  return (
    <div className="flex items-start gap-2">
      <PostCardHeaderActions {...props} />
    </div>
  );
};
